import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { catchError, exhaustMap, filter, map, mergeMap, of, tap } from 'rxjs';
import * as fromSharedActions from '../actions/shared.action'
import { ModalService } from 'src/app/services/modal.service';
import { SharedService } from 'src/app/services/shared.service';

@Injectable()
export class SharedEffects {

  setLoadingSpinner$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromSharedActions.setLoadingSpinner),
        tap(async (action) =>{
          if(action.status){
            this.modalService.showLoadingSpinner()
          } else{
            this.modalService.hideLoadingSpinner()
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private modalService: ModalService,
    private sharedService: SharedService
  ) {}

}
